import './Token-b3c86dc0.css';

var classes = {"Token":"prc-Token-Token-L2-At","LeadingVisualContainer":"prc-Token-LeadingVisualContainer-YTg7O","LargeLeadingVisual":"prc-Token-LargeLeadingVisual-UdxDk"};

export { classes as default };
